import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "addBusinessSlice",
  version: 1,
  storage,
  blacklist: [],
};

const initialState= {
    firstPage: {
      businessName: "",
      businessPhoneNo: "",
      businessEmail: "",
      businessCategory: "",
      businessWebsite: "",
    },
    secondPage: {
      streetNo: "",
      cityZip: "",
      cityOne: "",
      cityTwo: "",
      state: "",
    },
    keywords:[],
    thirdPage: {
      businessDescription: "",
      tags: [],
      dateAndTime: [
        {
          day: "MON",
          open_time: "",
          close_time: "",
          closed: false,
        },
        {
          day: "TUE",
          open_time: "",
          close_time: "",
          closed: false,
        },
        {
          day: "WED",
          open_time: "",
          close_time: "",
          closed: false,
        },
        {
          day: "THU",
          open_time: "",
          close_time: "",
          closed: false,
        },
        {
          day: "FRI",
          open_time: "",
          close_time: "",
          closed: false,
        },
        {
          day: "SAT",
          open_time: null,
          close_time: null,
          closed: true,
        },
        {
          day: "SUN",
          open_time: null,
          close_time: null,
          closed: true,
        },
      ],
    },
    fourthPage: {
      image: [],
      video: null,
      logo: null,
      baseImage:[]
    },
  };

export const addBusinessSlice = createSlice({
  name: "addbuisness",
  initialState,
  reducers: {
    
    setFirstPage: (state, action) => {
        state.firstPage=action.payload;
      },
      setSecondPage: (state, action) => {
        state.secondPage = action.payload;
      },
      setThirdPage: (state, action) => {
        state.thirdPage = action.payload;
      },
      setFourthPage: (state, action) => {
        state.fourthPage = action.payload;
      },
  },
});

export const { setFirstPage, setSecondPage, setThirdPage,setFourthPage } = addBusinessSlice.actions;

export default persistReducer(persistConfig, addBusinessSlice.reducer);
